import clsx from "clsx";
import { formatQueryMetric } from "components/QueryBuilder/Utils/QueryBuilderUtils";
import React from "react";

/**
 * Render the metric as it use to be + the prediction values when available
 * @returns
 */

const QueryBuilderTooltipMetric = ({
  metric,
  metricFriendlyName,
  currentTooltipData,
  isPrediction,
  color,
  metrics,
}) => {
  return (
    <div className="standard-tooltip__item">
      <span className="standard-tooltip__icon" style={{ background: color }} />
      <span className={clsx("standard-tooltip__key", "text-capitalize")}>
        {metricFriendlyName}
      </span>
      <br />
      <span className="standard-tooltip__value">
        {isPrediction
          ? ""
          : formatQueryMetric(metric, currentTooltipData[metric], metrics)}
      </span>
    </div>
  );
};

export default QueryBuilderTooltipMetric;
